import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

@Component({
    selector: 'app-reset-customer',
    templateUrl: './reset-customer.component.html',
    styleUrls: ['./reset-customer.component.scss'],
    standalone: false
})
export class ResetCustomerComponent implements OnInit {
  resetPassword!: UntypedFormGroup;

  myEmail: any;


  //  for icon 1nd

  visibles: boolean = false;
  changetypes: boolean = true

  viewpas() {
    this.visibles = !this.visibles;
    this.changetypes = !this.changetypes
  }


  visible: boolean = false;
  changetype: boolean = true;

  // myToken: any;

  viewpass() {
    this.visible = !this.visible;
    this.changetype = !this.changetype;

  }



  constructor(private fb: UntypedFormBuilder, http: HttpClient, public commonService: CommonService, private router: Router) { }

  ngOnInit(): void {

    this.resetPassword = this.fb.group({
      'password': new UntypedFormControl('', [
        Validators.required,
        // Validators.pattern("(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$")
        // Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'),
      ]),
      'confirmPassword': new UntypedFormControl('', Validators.required),
    })

    this.myEmail = localStorage.getItem('email')

  }



  navigateToResetPassword() {
    if(this.resetPassword.invalid){
      return this.commonService.errorToast("Please fill all required field.")
    }
    if(this.resetPassword.value.password != this.resetPassword.value.confirmPassword){
      return this.commonService.errorToast("Password and confirm password must be same.")
    }

    let apiReqData = {
      // userType: 'WHOLE_SALER',
      email: this.myEmail,
      newPassword: this.resetPassword.value.password,
      userType: localStorage.getItem('userType')

    }
    // var newPassword = { newPassword: this.resetPassword.value.password }
    // var token = localStorage.getItem('verifyOtpToken')
    this.commonService.showSpinner();
    this.commonService.putApi('user/resetPassword', apiReqData, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.commonService.hideSpinner();
        // this.router.navigate(['/change-password'])
        this.router.navigate(['/login'])
        // localStorage.removeItem("verifyOtpToken")
        this.commonService.showSuccessToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }


  preventSpace(event: any) {
    if ((event.charCode == 32 ) && !event.target.value) {
      event.preventDefault();
    }
  }
  showPassword: boolean = true
  changePasswordIcon() {
    this.showPassword = !this.showPassword;
  }
  changePasswordIcon1() {
    this.changetypes = !this.changetypes;
  }
}
